
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClient } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { HomeComponent } from './pages/home/home.component';
import { UniPageComponent } from './pages/uni-page/uni-page.component';
import { ProductComponent } from './pages/product/product.component';
import { CatalogComponent } from './pages/catalog/catalog.component';
import { MainSearchComponent } from './components/main-search/main-search.component';
import { SearchComponent } from './pages/search/search.component';
import { SearchViewComponent } from './components/main-search/search-view/search-view.component';
import { CatalogMainComponent } from './components/catalog-main/catalog-main.component';
import { BreadcrumbsComponent } from './components/bread-crumbs/bread-crumbs.component';
import { ContactsComponent } from './pages/contacts/contacts.component';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { RecaptchaModule } from "ng-recaptcha";
import { MetatagsService } from './components/seo-sitemap/metatags.service';
import { ProductListComponent } from './components/product-list/product-list.component'
import { provideClientHydration } from '@angular/platform-browser';




@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    UniPageComponent,
    ContactsComponent,
    ProductComponent,
    CatalogComponent,
    MainSearchComponent,
    SearchComponent,
    SearchViewComponent,
    CatalogMainComponent,
    BreadcrumbsComponent,
    ProductListComponent,
  ],
  imports: [
    RecaptchaModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,

  ],
  providers: [
    provideClientHydration(),
    HttpClient, MetatagsService],
  bootstrap: [AppComponent]
})
export class AppModule { }
